import { RootState } from '../store';
import { ClientTypes } from './slice';
import { useSelector } from 'react-redux';

export const rootSelector = (state: RootState) => state.client;

export const ClientSelectors = (): ClientTypes => {
    const selectedProjectId = useSelector(
        (state: RootState) => state.client.selectedProjectId
    );

    const isLoading = useSelector((state: RootState) => state.client.isLoading);

    const repositories = useSelector(
        (state: RootState) => state.client.repositories
    );

    const quests = useSelector((state: RootState) => state.client.quests);
    const totalQuests = useSelector(
        (state: RootState) => state.client.totalQuests
    );

    const workTimeReview = useSelector(
        (state: RootState) => state.client.workTimeReview
    );

    const questsRowsPerPage = useSelector(
        (state: RootState) => state.client.questsRowsPerPage
    );

    const questsSearchQuery = useSelector(
        (state: RootState) => state.client.questsSearchQuery
    );

    const questsStatusFilter = useSelector(
        (state: RootState) => state.client.questsStatusFilter
    );

    const questsCurrentPage = useSelector(
        (state: RootState) => state.client.questsCurrentPage
    );

    const onlyCurrentWork = useSelector(
        (state: RootState) => state.client.onlyCurrentWork
    );

    const planningSessions = useSelector(
        (state: RootState) => state.client.planningSessions
    );

    const totalPlanningSessions = useSelector(
        (state: RootState) => state.client.totalPlanningSessions
    );

    const planningSessionsRowsPerPage = useSelector(
        (state: RootState) => state.client.planningSessionsRowsPerPage
    );

    const planningSessionsCurrentPage = useSelector(
        (state: RootState) => state.client.planningSessionsCurrentPage
    );

    const planningSessionsSearchQuery = useSelector(
        (state: RootState) => state.client.planningSessionsSearchQuery
    );

    return {
        selectedProjectId,
        isLoading,
        repositories,
        quests,
        totalQuests,
        workTimeReview,
        questsRowsPerPage,
        questsSearchQuery,
        questsStatusFilter,
        questsCurrentPage,
        onlyCurrentWork,
        planningSessions,
        totalPlanningSessions,
        planningSessionsRowsPerPage,
        planningSessionsCurrentPage,
        planningSessionsSearchQuery
    };
};
